
import { useState } from 'react';
import ClipsHero from './components/ClipsHero';
import ClipsGallery from './components/ClipsGallery';
import UploadClip from './components/UploadClip';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import RegistrationModal from '../../components/feature/RegistrationModal';

export default function ClipsPage() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadSuccess = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-950">
      <Header onJoinClick={() => setIsRegistrationOpen(true)} />
      <ClipsHero onUploadClick={() => setIsUploadOpen(true)} />
      {isUploadOpen && (
        <UploadClip 
          onClose={() => setIsUploadOpen(false)} 
          onSuccess={handleUploadSuccess}
        />
      )}
      <ClipsGallery refreshTrigger={refreshTrigger} />
      <Footer />
      <RegistrationModal 
        isOpen={isRegistrationOpen} 
        onClose={() => setIsRegistrationOpen(false)} 
      />
    </div>
  );
}
